import { formMachine } from '../../../xform';
import cardNumberConfig from './cardNumberConfig';
import cvvConfig from './cvv2Config';
import expirationDateConfig from './expirationDateConfig';
import fullNameConfig from './fullNameConfig';
const createCardFormMachine = () => formMachine.withContext({
    fieldConfigs: [
        fullNameConfig(),
        cardNumberConfig(),
        expirationDateConfig(),
        cvvConfig()
    ]
});
export default createCardFormMachine;
